module.exports = {
  footerText: 'Copyright inciteai © 2022',
};
